function autoApplyManualDiscounts() {
    var storefrontAccessToken = "02b907e6c56029bf8d7911f333bce72b";
    fetch('/cart.js')
        .then(res => res.json())
        .then(cartJson => {
            // --- Collect coupon codes from line item properties ---
            const couponCodes = [];
            if (Array.isArray(cartJson.items)) {
                cartJson.items.forEach(item => {
                    if (item.properties) {
                        for (const key in item.properties) {
                            const match = key.match(/^_coupon_code-(.+)$/);
                            if (match) {
                                couponCodes.push(match[1]);
                            }
                        }
                    }
                });
            }

            const appliedCodes = (cartJson.discount_codes || []).map(dc => dc.code);
            const codesToApply = couponCodes.filter(code => !appliedCodes.includes(code));
            const allCodes = Array.from(new Set([...appliedCodes, ...codesToApply]));


            if (codesToApply.length > 0 && cartJson.token) {
                
                fetch('//'+window.Shopify.shop+'/api/2025-01/graphql.json', {
                    method: "POST",
                    headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': storefrontAccessToken },
                    body: JSON.stringify({
                    query: `
                        mutation {
                            cartDiscountCodesUpdate(cartId: "gid://shopify/Cart/`+cartJson.token+`", discountCodes: `+JSON.stringify(allCodes)+`) {
                                cart {
                                    id
                                    discountCodes{
                                        code
                                    }
                                }
                                userErrors {
                                    field
                                    message
                                }
                            }
                        }
                    `
                    })
                }).then((response) => response.json()).then((data) => {
                    // After all codes are applied, update cart drawer or refresh cart page
                    if(window.location.pathname.includes('/cart')) {
                        window.location.reload();
                    } else {
                        fetch(window.location.pathname)
                            .then(res => res.text())
                            .then(responseText => {
                                const html = new DOMParser().parseFromString(responseText, 'text/html');
                                const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
                                for (const selector of selectors) {
                                    const targetElement = document.querySelector(selector);
                                    const sourceElement = html.querySelector(selector);
                                    if (targetElement && sourceElement) {
                                        targetElement.replaceWith(sourceElement);
                                    }
                                    if(selector === 'cart-drawer-items') {
                                        document.querySelector('.cart-count-bubble span:first-child').textContent = sourceElement.dataset.itemCount || '0';
                                        document.querySelector('.cart-count-bubble span:last-child').textContent = (sourceElement.dataset.itemCount || '0') + ' item' + (sourceElement.dataset.itemCount !== '1' ? 's' : '');
                                    }
                                }
                            });
                    }
                });
            }
        });
}

window.addEventListener('DOMContentLoaded', () => {
    autoApplyManualDiscounts();
})

document.addEventListener('afterCartChanged', (event) => {
    if(event.detail.cartData.properties) {
        const couponCodes = [];
        for (const key in event.detail.cartData.properties) {
            const match = key.match(/^_coupon_code-(.+)$/);
            if (match) {
                couponCodes.push(match[1]);
            }
        }

        if (couponCodes.length > 0) {
            autoApplyManualDiscounts()
        }
    }
});